
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`What do I need to do to migrate to v5?`}</h2>
    <p>{`Ready for this?`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm install styled-components@^5.0.0 react@^16.8 react-dom@^16.8 react-is@^16.8
`}</code></pre>
    <p>{`If you're using React Native, you'll need at least v0.59 (the first version to support hooks.)`}</p>
    <p><em parentName="p">{`That's it.`}</em>{` 💥`}</p>
    <hr></hr>
    <p>{`styled-components v5 does not introduce any breaking public API changes, and adds the following:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Total rewrite of the core stylesheet engine, tuned for performance`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`New hooks-based component model`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`StyleSheetManager`}</inlineCode>{` has new props:`}</p>
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`disableCSSOMInjection`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`disableVendorPrefixes`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`stylisPlugins`}</inlineCode>
            <ul parentName="li">
              <li parentName="ul">{`try it with `}<a parentName="li" {...{
                  "href": "https://www.npmjs.com/package/stylis-plugin-rtl"
                }}><inlineCode parentName="a">{`stylis-plugin-rtl`}</inlineCode></a>{` for your bidi needs!`}</li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Note: The subfunction object-form `}<inlineCode parentName="p">{`.attrs({ prop: props => {} })`}</inlineCode>{` syntax that was deprecated in v4 is removed in v5. Use function-form attrs instead `}<inlineCode parentName="p">{`.attrs(props => ({}))`}</inlineCode>{` (you should have been seeing console warnings to make this update ahead of time.)`}</p>
    </blockquote>
    <p>{`Check out the `}<a parentName="p" {...{
        "href": "https://medium.com/styled-components/389747abd987"
      }}>{`official announcement post`}</a>{` for more information and to learn about what went into v5!`}</p>
    <h3>{`For jest users`}</h3>
    <p>{`Update to jest-styled-components v7:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm install jest-styled-components@^7.0.0
`}</code></pre>
    <h3>{`Note regarding css `}<inlineCode parentName="h3">{`@import`}</inlineCode>{` and `}<inlineCode parentName="h3">{`createGlobalStyle`}</inlineCode></h3>
    <p>{`At this time we do not recommend using `}<inlineCode parentName="p">{`@import`}</inlineCode>{` within cGS due to some issues with how browsers process `}<inlineCode parentName="p">{`@import`}</inlineCode>{` via the CSSOM APIs. Instead it's best to place these in your core `}<inlineCode parentName="p">{`index.html`}</inlineCode>{` file (generated or static) within a typical `}<inlineCode parentName="p">{`<style>`}</inlineCode>{` tag.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;